import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredInventories,
  selectInventoryLoading,
  selectfetchInventoryLoading,
} from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { deleteInventory } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const { INVENTORY_ADD_EDIT } = MODAL_TYPES;

const InventoryTable = ({ selectedType, onOpenDetailModal }) => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredInventories(state),
    isLoading: selectInventoryLoading(state) || selectfetchInventoryLoading(state),
  }));

  const filteredByType = filteredData.filter(item => {
    if (['FG', 'PL', 'IN'].includes(item.class)) {
      return item.class === selectedType;
    }

    return selectedType === 'Others';
  });

  const handleEditClick = record => {
    if (onOpenDetailModal) {
      onOpenDetailModal(record);
    }
  };

  const handleDeleteClick = id => {
    dispatch(deleteInventory(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [
    {
      title: 'PartNumber',
      dataIndex: 'partNumber',
      sorter: (a, b) => a.partNumber.length - b.partNumber.length,
    },
    {
      title: 'LocationName',
      dataIndex: 'locationName',
      sorter: (a, b) => a.locationName.length - b.locationName.length,
    },
    {
      title: 'FromDate',
      dataIndex: 'fromDate',
      sorter: (a, b) => a.fromDate.length - b.fromDate.length,
    },
    {
      title: 'ToDate',
      dataIndex: 'toDate',
      sorter: (a, b) => a.toDate.length - b.toDate.length,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (text, record) => (
        <span
          style={{
            backgroundColor: record.backgroundColor,
            color: record.textColor,
            padding: '4px 8px',
            borderRadius: '4px',
          }}
        >
          {text}
        </span>
      ),
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredByType} />
    </div>
  );
};

export default InventoryTable;
